<template>
  <div class="space-y-6">
    <div>
      <h1 class="text-2xl font-bold text-gray-900">仪表盘</h1>
      <p class="mt-1 text-sm text-gray-600">
        Apache Kafka PMC 成员活动概览
      </p>
    </div>

    <div class="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <div class="card p-5">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="h-8 w-8 bg-red-500 rounded flex items-center justify-center">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
              </svg>
            </div>
          </div>
          <div class="ml-5 w-0 flex-1">
            <dl>
              <dt class="text-sm font-medium text-gray-500 truncate">
                JIRA Issues
              </dt>
              <dd class="text-lg font-medium text-gray-900">
                {{ totalIssues }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="mt-3">
          <router-link
            to="/jira"
            class="text-sm text-primary-600 hover:text-primary-500"
          >
            查看详情 →
          </router-link>
        </div>
      </div>

      <div class="card p-5">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="h-8 w-8 bg-blue-500 rounded flex items-center justify-center">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
              </svg>
            </div>
          </div>
          <div class="ml-5 w-0 flex-1">
            <dl>
              <dt class="text-sm font-medium text-gray-500 truncate">
                开放 PRs
              </dt>
              <dd class="text-lg font-medium text-gray-900">
                {{ totalPRs }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="mt-3">
          <router-link
            to="/prs"
            class="text-sm text-primary-600 hover:text-primary-500"
          >
            查看详情 →
          </router-link>
        </div>
      </div>

      <div class="card p-5">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="h-8 w-8 bg-green-500 rounded flex items-center justify-center">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
          </div>
          <div class="ml-5 w-0 flex-1">
            <dl>
              <dt class="text-sm font-medium text-gray-500 truncate">
                已合并 PRs
              </dt>
              <dd class="text-lg font-medium text-gray-900">
                {{ totalMergedPRs }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="mt-3">
          <router-link
            to="/merged-prs"
            class="text-sm text-primary-600 hover:text-primary-500"
          >
            查看详情 →
          </router-link>
        </div>
      </div>

      <div class="card p-5">
        <div class="flex items-center">
          <div class="flex-shrink-0">
            <div class="h-8 w-8 bg-purple-500 rounded flex items-center justify-center">
              <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"></path>
              </svg>
            </div>
          </div>
          <div class="ml-5 w-0 flex-1">
            <dl>
              <dt class="text-sm font-medium text-gray-500 truncate">
                自定义成员
              </dt>
              <dd class="text-lg font-medium text-gray-900">
                {{ totalCustomMembers }}
              </dd>
            </dl>
          </div>
        </div>
        <div class="mt-3">
          <router-link
            to="/manage-members"
            class="text-sm text-primary-600 hover:text-primary-500"
          >
            管理成员 →
          </router-link>
        </div>
      </div>
    </div>

    <div class="card p-6">
      <h2 class="text-lg font-medium text-gray-900 mb-4">快速操作</h2>
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <button
          @click="loadJiraData"
          :disabled="loading"
          class="btn btn-primary w-full flex items-center justify-center space-x-2"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
          <span>加载 JIRA Issues</span>
        </button>
        
        <button
          @click="loadGitHubData"
          :disabled="loading"
          class="btn btn-primary w-full flex items-center justify-center space-x-2"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
          </svg>
          <span>加载 GitHub PRs</span>
        </button>
        
        <button
          @click="loadMergedData"
          :disabled="loading"
          class="btn btn-primary w-full flex items-center justify-center space-x-2"
        >
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          <span>加载已合并 PRs</span>
        </button>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div class="card p-6">
        <h2 class="text-lg font-medium text-gray-900 mb-4">最近 JIRA Issues</h2>
        <div v-if="recentJiraIssues.length === 0" class="text-gray-500 text-center py-4">
          暂无数据
        </div>
        <div v-else class="space-y-3">
          <div
            v-for="issue in recentJiraIssues"
            :key="issue.key"
            class="border-l-4 border-red-400 pl-3 py-2"
          >
            <div class="flex items-start justify-between">
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-900 truncate">
                  {{ issue.key }}: {{ issue.summary }}
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  {{ issue.assignee }} • {{ formatDate(issue.updated) }}
                </p>
              </div>
              <a
                :href="issue.url"
                target="_blank"
                class="ml-2 text-primary-600 hover:text-primary-500 text-xs"
              >
                查看 →
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="card p-6">
        <h2 class="text-lg font-medium text-gray-900 mb-4">最近 GitHub PRs</h2>
        <div v-if="recentGitHubPRs.length === 0" class="text-gray-500 text-center py-4">
          暂无数据
        </div>
        <div v-else class="space-y-3">
          <div
            v-for="pr in recentGitHubPRs"
            :key="pr.id"
            class="border-l-4 border-blue-400 pl-3 py-2"
          >
            <div class="flex items-start justify-between">
              <div class="flex-1 min-w-0">
                <p class="text-sm font-medium text-gray-900 truncate">
                  #{{ pr.number }}: {{ pr.title }}
                </p>
                <p class="text-xs text-gray-500 mt-1">
                  {{ pr.author }} • {{ formatDate(pr.updatedAt) }}
                </p>
              </div>
              <a
                :href="pr.url"
                target="_blank"
                class="ml-2 text-primary-600 hover:text-primary-500 text-xs"
              >
                查看 →
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/stores'

const store = useAppStore()

// 使用 storeToRefs 保持响应式
const {
  loading,
  jiraIssues,
  githubPRs,
  mergedPRs,
  totalIssues,
  totalPRs,
  totalMergedPRs,
  totalCustomMembers
} = storeToRefs(store)

const recentJiraIssues = computed(() => {
  return jiraIssues.value.slice(0, 5)
})

const recentGitHubPRs = computed(() => {
  return githubPRs.value.slice(0, 5)
})

// 方法
const formatDate = (dateString) => {
  if (!dateString) return '未知'
  
  const date = new Date(dateString)
  const now = new Date()
  const diffInHours = (now - date) / (1000 * 60 * 60)
  
  if (diffInHours < 24) {
    return `${Math.floor(diffInHours)}小时前`
  } else {
    const diffInDays = Math.floor(diffInHours / 24)
    return `${diffInDays}天前`
  }
}

const loadJiraData = async () => {
  try {
    await store.fetchJiraIssues()
  } catch (error) {
    console.error('Failed to load JIRA data:', error)
  }
}

const loadGitHubData = async () => {
  try {
    await store.fetchGitHubPRs()
  } catch (error) {
    console.error('Failed to load GitHub data:', error)
  }
}

const loadMergedData = async () => {
  try {
    await store.fetchMergedPRs()
  } catch (error) {
    console.error('Failed to load merged PR data:', error)
  }
}

// 生命周期
onMounted(() => {
  // 页面加载时自动获取数据
  Promise.allSettled([
    store.fetchJiraIssues(),
    store.fetchGitHubPRs(),
    store.fetchMergedPRs(),
    store.fetchCustomMembers()
  ])
})
</script> 